import API from '../config/api';
import React, { useState, useEffect } from 'react';

import axios from 'axios';
import { toast } from 'react-toastify';

import {
  Container,
  Card,
  Row,
  Col,
  Badge,
  Spinner,
  Form,
  Button
} from 'react-bootstrap';

import { useParams } from 'react-router-dom';

import CustomNavbar from '../components/CustomNavbar';

function AdminTicketDetailsPage() {
  const { id } = useParams();

  const [ticket, setTicket] = useState(null);

  const [loading, setLoading] = useState(true);

  const [status, setStatus] = useState('');

  const [adminReply, setAdminReply] = useState('');

  useEffect(() => {
    const fetchTicket = async () => {
      try {
        const { data } = await axios.get(
          `${API}/tickets/${id}`
        );

        setTicket(data);

        setStatus(data.status);

        setAdminReply(data.adminReply || '');
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    fetchTicket();
  }, [id]);

  if (loading) {
    return (
      <>
        <CustomNavbar />

        <Container className="text-center py-5">
          <Spinner animation="border" />
        </Container>
      </>
    );
  }
  const saveChanges = async () => {
    try {
      await axios.put(
        `${API}/tickets/${id}`,

        {
          status,
          adminReply
        }
      );

      toast.success('Ticket Updated Successfully');
    } catch (error) {
      console.log(error);

      toast.error('Failed To Update Ticket');
    }
  };
  const statusColor =
    ticket.status === 'Open'
      ? '#ef4444'
      : ticket.status === 'In Progress'
        ? '#f59e0b'
        : '#22c55e';

  const statusBg =
    ticket.status === 'Open'
      ? 'danger'
      : ticket.status === 'In Progress'
        ? 'warning'
        : 'success';

  const infoItems = [
    { icon: '🆔', label: 'Ticket ID', value: ticket._id },
    {
      icon: '📅',
      label: 'Created',
      value: new Date(ticket.createdAt).toLocaleString()
    },
    { icon: '📦', label: 'Product', value: ticket.productName || 'N/A' },
    { icon: '🧾', label: 'Order ID', value: ticket.orderId || 'N/A' },
    { icon: '🏷️', label: 'Category', value: ticket.category },
    { icon: '📌', label: 'Subject', value: ticket.subject }
  ];

  return (
    <>
      <CustomNavbar />

      <div className="atd-wrap">
        <Container>
          {/* Header */}
          <Card
            className="border-0 shadow-lg mb-4 atd-hero"
            style={{ borderLeft: `8px solid ${statusColor}` }}
          >
            <Card.Body className="p-4 d-flex flex-wrap justify-content-between align-items-center gap-3">
              <div className="d-flex align-items-center gap-3">
                <span
                  className="atd-avatar"
                  style={{ background: statusColor }}
                >
                  {ticket.name?.charAt(0).toUpperCase()}
                </span>
                <div>
                  <h4 className="fw-bold mb-0">{ticket.subject}</h4>
                  <small className="text-muted">
                    🎫 #{ticket._id.slice(-6)} · {ticket.name}
                  </small>
                </div>
              </div>
              <Badge bg={statusBg} className="rounded-pill px-3 py-2 fs-6">
                {ticket.status}
              </Badge>
            </Card.Body>
          </Card>

          <Row className="g-4">
            {/* Left: details */}
            <Col lg={7}>
              <Card className="border-0 shadow-sm mb-4 atd-card">
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">📋 Ticket Details</h5>
                  <Row className="g-3">
                    {infoItems.map((item, i) => (
                      <Col sm={6} key={i}>
                        <div className="atd-info">
                          <div className="atd-info-label">
                            {item.icon} {item.label}
                          </div>
                          <div className="atd-info-value">{item.value}</div>
                        </div>
                      </Col>
                    ))}
                    <Col xs={12}>
                      <div className="atd-info">
                        <div className="atd-info-label">✉️ Customer Email</div>
                        <div className="atd-info-value">{ticket.email}</div>
                      </div>
                    </Col>
                  </Row>
                </Card.Body>
              </Card>

              <Card className="border-0 shadow-sm atd-card">
                <Card.Body className="p-4">
                  <h5 className="fw-bold mb-3">💬 Customer Message</h5>
                  <div className="atd-message">{ticket.message}</div>
                </Card.Body>
              </Card>
            </Col>

            {/* Right: actions */}
            <Col lg={5}>
              <Card className="border-0 shadow-sm atd-card atd-action-card">
                <div className="atd-action-header">
                  <h5 className="mb-0 fw-bold">⚙️ Manage Ticket</h5>
                </div>
                <Card.Body className="p-4">
                  <Form.Label className="atd-form-label">
                    Update Status
                  </Form.Label>
                  <Form.Select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="mb-4"
                  >
                    <option>Open</option>
                    <option>In Progress</option>
                    <option>Closed</option>
                  </Form.Select>

                  <Form.Label className="atd-form-label">
                    Admin Reply
                  </Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={6}
                    value={adminReply}
                    onChange={(e) => setAdminReply(e.target.value)}
                    placeholder="Write your reply to the customer..."
                    className="mb-2"
                  />
                  <small className="text-muted d-block mb-4">
                    📧 The customer will be notified by email.
                  </small>

                  <Button
                    size="lg"
                    onClick={saveChanges}
                    className="w-100 fw-bold atd-save-btn"
                  >
                    💾 Save Changes
                  </Button>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <style>{ticketDetailsStyles}</style>
    </>
  );
}

const ticketDetailsStyles = `
  .atd-wrap {
    background: radial-gradient(720px 320px at 8% -5%, rgba(124,58,237,0.12), transparent 70%), radial-gradient(720px 320px at 92% 105%, rgba(234,88,12,0.14), transparent 70%), linear-gradient(180deg, #faf5ff 0%, #fff7ed 55%, #fef3c7 100%);
    min-height: 100vh;
    padding: clamp(24px, 4vw, 48px) 0;
  }

  .atd-hero {
    border-radius: 18px;
  }
  .atd-avatar {
    width: 56px;
    height: 56px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    color: #fff;
    font-weight: 800;
    font-size: 1.5rem;
  }

  .atd-card {
    border-radius: 18px;
  }

  .atd-info {
    background: #f8fafc;
    border-radius: 12px;
    padding: 10px 14px;
    height: 100%;
  }
  .atd-info-label {
    font-size: 0.68rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.4px;
    color: #94a3b8;
    margin-bottom: 2px;
  }
  .atd-info-value {
    font-weight: 600;
    color: #1e293b;
    word-break: break-word;
  }

  .atd-message {
    background: #fff7ed;
    border-left: 4px solid #ea580c;
    border-radius: 10px;
    padding: 16px 18px;
    color: #334155;
    line-height: 1.7;
    white-space: pre-wrap;
  }

  .atd-action-card {
    overflow: hidden;
    position: sticky;
    top: 90px;
  }
  .atd-action-header {
    background: linear-gradient(120deg, #c2410c, #ea580c);
    color: #fff;
    padding: 16px 24px;
  }
  .atd-form-label {
    font-size: 0.8rem;
    font-weight: 700;
    color: #4338ca;
    margin-bottom: 6px;
  }
  .atd-action-card .form-control,
  .atd-action-card .form-select {
    border-radius: 12px;
    padding: 11px 14px;
  }
  .atd-action-card .form-control:focus,
  .atd-action-card .form-select:focus {
    border-color: #ea580c;
    box-shadow: 0 0 0 0.2rem rgba(234, 88, 12,0.15);
  }
  .atd-save-btn {
    border: none;
    border-radius: 12px;
    background: linear-gradient(135deg, #c2410c, #ea580c);
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }
  .atd-save-btn:hover {
    background: linear-gradient(135deg, #4338ca, #b45309);
    transform: translateY(-2px);
    box-shadow: 0 12px 26px rgba(234, 88, 12,0.4);
  }

  @media (max-width: 991.98px) {
    .atd-action-card { position: static; }
  }
`;

export default AdminTicketDetailsPage;
